import { CommonModule, Location } from '@angular/common';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { openClaraChatLauncher } from "@common/utils/open-clara-chat.util";
import { TipoMensajeSalidaFlujoTramitePension } from '@constants/business.constant';
import {
  ACCOUNTS,
  BASIC_CLIENT_INFO,
  RECOGNITION_BONDS,
  ULTIMAS_12_COTIZACIONES,
} from "@constants/data-service.constant";
import {
  BENEFICIARIES,
  DATA_UPDATE,
  HOME_URL,
  INICIO,
  PROFILE,
  REQUEST_ERROR,
  ROUTING_ESTADO_TRAMITE_PENSION,
  ROUTING_TRAMITE_PENSION,
} from "@constants/url.constant";
import { IValidateCivilStatus } from "@interfaces/validate-civil-status.interface";
import { IonicModule } from '@ionic/angular';
import { GtmService } from '@services/gtm/gtm.service';
import { ModalService } from "@services/modal/modal.service";
import { StorageService } from "@services/storage/storage.service";
import {
  CODIGO_VALIDACIONES_EXITOSA,
  CODIGOS_VALIDACIONES_TRAMITE_EN_CURSO,
  CODIGOS_VALIDACIONES_TRAMITE_EN_PROCESO,
  LabelStatus,
  MENSAJES_LISTA_ERRORES_BENEFICIARIOS,
  MESSAGE,
  SESSION_TRAMITE_PENSION_ERROR_GENERAL_INICIO_REINTENTOS_RESTANTES,
  STORAGE_FORM_VIA_PAGO,
  STORAGE_FORMULARIO_DATOS_PERSONALES,
  STORAGE_TIPO_TRAMITE,
  TIPO_TRAMITE_FLUJO,
  TipoErrorValidacionBeneficiarios,
  TP_BENEFICIARIES,
  TP_MODAL_ACTIVO,
  TP_PERSONAL_DATA,
  TRAMITE_PENSION_ERROR_GENERAL_INICIO_MAX_REINTENTOS,
  TramitePensionFlowsEnum,
  VEJEZ_EDAD
} from "@shared/common/constants/tramite-pension-constant";
import { Beneficiary } from "@shared/common/interfaces/beneficiario.interface";
import { ModalBeneficioReforma } from "@shared/common/interfaces/modal-beneficios-reforma-tramite-pension.interface";
import { TramiteSolicitudPension } from "@shared/common/interfaces/tramite-pension-v2.interface";
import { Util } from "@shared/common/utils/util";
import { ModalPasosTramitePensionComponent, TramitePensionStep } from "@shared/components";
import { ModalReformaTramitePensionComponent } from "@shared/components/modal-reforma-tramite-pension/modal-reforma-tramite-pension.component";
import { TooltipInfoDirective } from '@shared/directives/tooltip-info.directive';
import { catchError, firstValueFrom, of } from "rxjs";
import { take } from "rxjs/internal/operators/take";
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import { PiModalBonoAmortizableComponent } from "src/app/tramite-pension-invalidez/components/pi-modal-bono-amortizable/pi-modal-bono-amortizable.component";
import { CheckCircleTramiteIconComponent } from 'src/assets/tramite-pension/icons/svg/check-circle/check-circle.component';
import { InfoCircleTramiteIconComponent } from 'src/assets/tramite-pension/icons/svg/i-circle/i-circle.component';
import { WarningTramiteIconComponent } from 'src/assets/tramite-pension/icons/svg/warning/warning.component';
import {
  CertificadoService,
  TrabajosPesadosResponse,
} from "../../../estado-tramite-pension/services/certificado.service";
import { BonoReconocimiento } from "../../../shared/common/interfaces/bono-reconocimiento.interface";
import { PensionEnTramitePension } from "../../../shared/common/interfaces/tramite-pension.interface";
import { BeneficiariosValidadorService } from "../../services/beneficiarios-validador.service";
import { TramitePensionService } from "../../services/tramite-pension.service";
import { TramiteStepperService } from "../../services/tramite-stepper.service";
@Component({
  selector: "app-tramite-pension-home",
  templateUrl: "tramite-pension-home.component.html",
  styleUrls: ["tramite-pension-home.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    InfoCircleTramiteIconComponent,
    CheckCircleTramiteIconComponent,
    WarningTramiteIconComponent,
    TooltipInfoDirective,
  ],
})
export class TramitePensionHomeComponent implements OnInit, OnDestroy {
  /** Texto del tooltip [Tooltip-Info] junto a «Actualizar tus beneficiarios» (patrón AFP / `pensionados-tooltip-surface`). */
  readonly textoTooltipBeneficiario =
    'Personas que podrían recibir una pensión en caso de tu fallecimiento.';

  readonly textoTooltipSectorPublico =
    'Persona que trabaja en una institución del Estado, como ministerios, municipalidades u otras entidades.';

  tramitePensionFlowsEnum = TramitePensionFlowsEnum;
  readonly labelStatus = LabelStatus;
  modalBeneficiosReforma: ModalBeneficioReforma;
  pasosTramite: TramitePensionStep[] = [
    {
      numero: 1,
      titulo: "Validación de identidad",
      descripcion: "Te pediremos verificar tu identidad con Clave de Seguridad o Clave Dinámica (correo o SMS).",
    },
    {
      numero: 2,
      titulo: "Revisión de datos",
      descripcion: "Validarás que tu información personal, beneficiarios y saldos de tus cuentas sea correcta.",
    },
    {
      numero: 3,
      titulo: "Antecedentes de pensión",
      descripcion: "Responderás algunas preguntas según tu situación.",
    },
    {
      numero: 4,
      titulo: "Vía de pago",
      descripcion: "Nos indicarás dónde quieres recibir el pago de tu pensión.",
    },
    {
      numero: 5,
      titulo: "Documentos",
      descripcion: "Adjuntarás los certificados requeridos, si corresponde.",
    },
    {
      numero: 6,
      titulo: "Confirmación",
      descripcion: "Encontrarás un resumen de la información ingresada, para luego confirmar y enviar tu solicitud.",
    },
  ];
  currentFlow: TramitePensionFlowsEnum | null = null;
  statusFlow = this.tramitePensionFlowsEnum.INICIAR_TRAMITE;
  clientInfo: any;
  statusInfo: any;

  get numeroSolicitudTramite(): string {
    return (
      this.estadoTramite?.numeroTramite ??
      this.tramiteSolicitudMasReciente?.numeroTramite ??
      "—"
    );
  }

  get fechaPresentacionTramite(): string {
    const fecha =
      this.estadoTramite?.fechaSolicitudTramite ??
      this.tramiteSolicitudMasReciente?.fechaSolicitudTramite;
    return fecha?.trim() ? fecha : "—";
  }

  get mostrarTextoHeroIniciarTramite(): boolean {
    return this.statusInfo === LabelStatus.INICIAR_TRAMITE;
  }

  get mostrarTextoHeroTramitePresentado(): boolean {
    return (
      this.statusInfo === LabelStatus.TRAMITE_EN_CURSO ||
      this.statusInfo === LabelStatus.TRAMITE_FINALIZADO
    );
  }

  get correoClienteHero(): string {
    return this.clientInfo?.email?.trim() || "—";
  }

  get fechaIngresoTramiteHero(): string {
    return this.fechaPresentacionTramite;
  }

  get claseBadgeEstadoTramite(): string {
    if (this.statusInfo?.estadoTramite === LabelStatus.TRAMITE_FINALIZADO.estadoTramite) {
      return "badge-status badge-status--presentado";
    }
    if (this.statusInfo?.estadoTramite === LabelStatus.TRAMITE_EN_CURSO.estadoTramite) {
      return "badge-status badge-status--en-curso";
    }
    return "badge-status";
  }

  steps: string = "";
  btnText: string = "Iniciar solicitud";
  applicationData: any;
  loading: boolean = false;
  estadoTramite: PensionEnTramitePension;
  mostrarNumeroTramite = true;
  mostrarBotonEstado = false;
  tramiteSolicitudMasReciente: TramiteSolicitudPension | null = null;
  loadingHome: boolean = true;
  private clienteTieneSaldoCongelado: boolean = false;
  checkNoSoyEmpleadoPublico: boolean = false;
  checkNoSumaAhorrosVoluntarios: boolean = false;
  checkBonoAmortizable: boolean = false;
  showBonoCheck = true;
  token: string = "";
  modalActivado: boolean = false;

  private modalTimer: any;
  private bonoModalAbierto = false;

  private routerSubscription: any;
  private necesitaReinicializar: boolean = false;

  constructor(
    private readonly storageService: StorageService,
    private readonly activatedRoute: ActivatedRoute,
    readonly router: Router,
    private readonly tramiteStepper: TramiteStepperService,
    private readonly tramitePension: TramitePensionService,
    private readonly util: Util,
    private readonly modalService: ModalService,
    private readonly location: Location,
    private readonly certificadoService: CertificadoService,
    private readonly beneficiariosValidador: BeneficiariosValidadorService,
    private readonly gtmService: GtmService,
    private readonly cdr: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    void this.initializeComponent();
  }

  ionViewWillEnter() {
    if (this.necesitaReinicializar) {
      this.necesitaReinicializar = false;
      this.loadingHome = true;
      void this.initializeComponent();
    }
  }

  private async initializeComponent() {
    this.token = await this.util.getIdToken();
    this.clientInfo = await this.storageService.get(BASIC_CLIENT_INFO);
    this.clienteTieneSaldoCongelado = await this.tramitePension.obtenerSaldoCongelado() ?? false;
    await this.setprocessInfo();
    await this.getCurrentFlow();
  }

  openModalReformaTramitePension(modalBeneficiosReforma: ModalBeneficioReforma): void {
    this.gtmService.trackClick('button', 'Conoce Más', 'boton_secundario', 'modal');
    void this.modalService.openCustomModal({
      component: ModalReformaTramitePensionComponent,
      backdropDismiss: false,
      cssClass: "modal-reforma-tramite-pension",
      componentProps: {
        modalBeneficiosReforma: modalBeneficiosReforma
      }
    })

  }

  openModalPasosTramitePension(): void {
    this.gtmService.trackClick('button', 'Revisa los Pasos', 'boton_secundario', 'modal');
    void this.modalService.openCustomModal({
      component: ModalPasosTramitePensionComponent,
      cssClass: ["generic-modal", "steps-tramite-pension-modal"],
      backdropDismiss: false,
      componentProps: {
        titulo: "Pasos para presentar tu solicitud de pensión",
        descripcion: "Te contamos los pasos para realizar la solicitud en línea:",
        pasos: this.pasosTramite,
        textoBotonPrimario: "Ir a la solicitud",
      },
    });
  }

  async openModalBonoAmortizable(event: Event): Promise<void> {
    event.preventDefault();
    event.stopPropagation();

    if (this.bonoModalAbierto) {
      return;
    }

    this.setCheckBonoAmortizable(false);
    this.bonoModalAbierto = true;

    try {
      const result = await this.modalService.openCustomModal({
        component: PiModalBonoAmortizableComponent,
        cssClass: ["generic-modal", "pi-modal-bono-amortizable"],
        backdropDismiss: true,
      });

      const data = result?.data as { confirmed?: boolean } | undefined;
      const confirmed =
        result?.role === "confirm" || data?.confirmed === true;
      // Solo queda true si confirmó; X / backdrop / Escape → false.
      this.setCheckBonoAmortizable(!!confirmed);
    } finally {
      this.bonoModalAbierto = false;
    }
  }

  private setCheckBonoAmortizable(value: boolean): void {
    this.checkBonoAmortizable = value;
    this.showBonoCheck = false;
    this.cdr.detectChanges();
    this.showBonoCheck = true;
    this.cdr.detectChanges();
  }

  private async getCurrentFlow(): Promise<void> {
    const accounts = (await this.storageService.get("accounts")) || [];
    // get cuentas obligatorias apo - cco
    const cuentasObligatorias: any[] = accounts.filter(
      (account: { id: string }) => account.id === "APO" || account.id === "CCO"
    );
    // get cuentas CDC (deposito convenido)
    const cuentasCDC: any[] = accounts.filter(
      (account: { id: string }) => account.id === "CDC"
    );
    // get another accounts
    const anotherAccounts: any[] = accounts.filter(
      (account: { id: string }) =>
        account.id !== "CDC" && account.id !== "APO" && account.id !== "CCO"
    );

    // Cliente debe tener solo cuenta obligatoria y/o CDC
    if (cuentasObligatorias.length > 0 || cuentasCDC.length > 0) {
      this.currentFlow = TramitePensionFlowsEnum.VIDEO_ATENCION;
    }
    // Si tiene solo CDC no puede entrar al flujo (video atención)
    if (cuentasCDC.length > 0 && cuentasObligatorias.length === 0) {
      this.currentFlow = TramitePensionFlowsEnum.VIDEO_ATENCION;
    }
    // Si tiene cuentas distintas a CDC y CCO tampoco entra al flujo de trámite (video atención)
    if (
      anotherAccounts.length > 0 ||
      cuentasObligatorias.some(
        (account: { id: string }) => account.id === "APO"
      )
    ) {
      this.currentFlow = TramitePensionFlowsEnum.VIDEO_ATENCION;
    }

    /*
    Cliente no debe tener bono de reconocimiento (verificar los estados que no aplican) (se abordará en HU aparte)
    Cliente solo debe tener como beneficiario a un cónyuge sin hijos con derecho a pensión de sobrevivencia o bien no tener cónyuge  (se abordará en HU aparte)
    Cliente no debe tener un empleador vigente (se abordará en HU aparte)
    Si cumple con las condiciones antes descritas puede ingresar un trámite de pensión
    Si no cumple alguna validación se activa flujo alternativo de agendar video atención (va en otra HU).
    */
    if (!this.currentFlow) {
      this.currentFlow = TramitePensionFlowsEnum.INICIAR_TRAMITE;
    }
  }

  goToYourData() {
    this.router.navigate([DATA_UPDATE, HOME_URL, PROFILE]);
  }

  goToYourBeneficiaries() {
    this.router.navigate([DATA_UPDATE, BENEFICIARIES, HOME_URL]);
  }

  async iniciarTramite() {
    this.loading = true;
    try {
      this.tramitePension.clearCache();
      await this.storageService.remove(STORAGE_FORM_VIA_PAGO);
      sessionStorage.removeItem(STORAGE_FORMULARIO_DATOS_PERSONALES);
      this.tramitePension.clearError();
      this.gtmService.trackClick('button', 'Iniciar solicitud', 'boton_principal', 'pensions/tramite-pensiones/seguridad');

      if (this.clienteTieneSaldoCongelado) {
        this.enviarAPaginaDeError();
        return;
      }

      const personalData = await firstValueFrom(
        this.tramitePension.getPersonalData()
      );

      await this.storageService.set(TP_PERSONAL_DATA, personalData);

      if (personalData.codigoPaisNacionalidad !== "CL") {
        this.enviarAPaginaDeError("extranjero");
        return;
      }

      const estadoCivil = personalData?.estadoCivil;
      if (!(await this.iniciarTramiteValidarEstadoCivil(personalData))) {
        return;
      }

      // Sin CCO: pantalla de ahorros obligatorios (antes de otras APIs que pueden fallar).
      const tieneCCO = await this.validaProductoCliente();
      if (!tieneCCO) {
        this.enviarAPaginaDeErrorPorValidacion(
          MESSAGE.ERROR_NO_AHORROS_OBLIGATORIOS_AFP_CAPITAL
        );
        return;
      }

      const { desde, hasta } = this.util.periodoCertificados(0);
      const rut = await this.tramitePension.uid();

      // Obtener todos los datos en paralelo (incluye beneficiarios)
      const [
        sinBonoReconocimientoValido,
        afiliadoSinEmpleador,
        trabajosPesadosResponse,
        beneficiaries
      ] = await Promise.all([
        this.clienteSinBonoReconocimiento(),
        this.checkAfiliadoSinEmpleador(),
        this.certificadoService.obtenerTrabajosPesados({
          rut,
          dateIni: `01/${desde.substring(4, 6)}/${desde.substring(0, 4)}`,
          dateFin: `01/${hasta.substring(4, 6)}/${hasta.substring(0, 4)}`
        }),
        this.obtenerYGuardarBeneficiarios()
      ]);

      await this.finalizarIniciarTramiteDespuesDeValidacionesParalelas(
        personalData,
        estadoCivil,
        beneficiaries,
        tieneCCO,
        sinBonoReconocimientoValido,
        afiliadoSinEmpleador,
        trabajosPesadosResponse
      );
    } catch (error) {
      this.loading = false;
      console.error("Error al iniciar el trámite", error);
      this.enviarAPaginaDeErrorGeneral();
    }
  }

  // Metodo creado para validar los datos y redirigir al paso correspondiente
  private async finalizarIniciarTramiteDespuesDeValidacionesParalelas(
    personalData: any,
    estadoCivil: string,
    beneficiaries: Beneficiary[] | null,
    tieneCCO: boolean,
    sinBonoReconocimientoValido: boolean,
    afiliadoSinEmpleador: boolean,
    trabajosPesadosResponse: TrabajosPesadosResponse
  ): Promise<void> {

    if (!tieneCCO) {
      this.enviarAPaginaDeErrorPorValidacion(MESSAGE.ERROR_NO_AHORROS_OBLIGATORIOS_AFP_CAPITAL);
      return;
    }

    const validacionBeneficiarios = this.beneficiariosValidador.validarBeneficiarios(
      beneficiaries,
      estadoCivil,
      personalData?.apellidoPaterno ?? ''
    );

    if (validacionBeneficiarios.erroresMandatorios.length > 0) {
      const errorMandatorio = validacionBeneficiarios.erroresMandatorios[0];

      if (errorMandatorio === TipoErrorValidacionBeneficiarios.ERROR_SERVICIO) {
        this.loading = false;
        this.enviarAPaginaDeErrorGeneral();
        return;
      } else if (errorMandatorio === TipoErrorValidacionBeneficiarios.BENEFICIARIO_CON_INVALIDEZ) {
        this.enviarAPaginaDeErrorBeneficiarioConInvalidez();
        return;
      }
    }

    if (validacionBeneficiarios.erroresAgrupados.length > 0) {
      this.enviarAPaginaDeErrorBeneficiariosAgrupados(validacionBeneficiarios.erroresAgrupados);
      return;
    }

    const tieneEdadLegalDePension = this.util.tieneEdadLegalDePension(
      personalData?.fechaNacimiento ?? "",
      personalData?.sexo ?? "",
      trabajosPesadosResponse.data.totalRebaja
    );

    this.storageService.set(STORAGE_TIPO_TRAMITE, TIPO_TRAMITE_FLUJO.VEJEZ_NORMAL);

    if (
      afiliadoSinEmpleador &&
      sinBonoReconocimientoValido &&
      tieneEdadLegalDePension
    ) {
      this.storageService.set(
        "password_validation_return_url",
        `/pensions/tramite-pensiones/solicitud/datos-personales`
      );
      this.tramiteStepper.setStepCurrent(1);
      this.clientInfo = await this.storageService.get(BASIC_CLIENT_INFO);
      const { email, cellphoneNumber } = this.clientInfo;

      if (email || cellphoneNumber) {
        this.loading = false;
        sessionStorage.removeItem(
          SESSION_TRAMITE_PENSION_ERROR_GENERAL_INICIO_REINTENTOS_RESTANTES
        );
        this.router.navigate(
          [`/${ROUTING_TRAMITE_PENSION.BASE_URL}/${ROUTING_TRAMITE_PENSION.REQUEST}`],
          { relativeTo: this.activatedRoute }
        );
      }
    } else {
      this.enviarAPaginaDeError();
    }
  }

  private enviarAPaginaDeErrorGeneral() {
    if (
      sessionStorage.getItem(SESSION_TRAMITE_PENSION_ERROR_GENERAL_INICIO_REINTENTOS_RESTANTES) ===
      null
    ) {
      sessionStorage.setItem(
        SESSION_TRAMITE_PENSION_ERROR_GENERAL_INICIO_REINTENTOS_RESTANTES,
        String(TRAMITE_PENSION_ERROR_GENERAL_INICIO_MAX_REINTENTOS)
      );
    }
    this.necesitaReinicializar = true;
    this.loadingHome = false;
    this.tramitePension.setError(MESSAGE.ERROR_GENERAL_INICIAR_TRAMITE);
    this.router.navigate(
      [`/${ROUTING_TRAMITE_PENSION.BASE_URL}/${REQUEST_ERROR}`],
      { relativeTo: this.activatedRoute }
    );
  }

  private async iniciarTramiteValidarEstadoCivil(personalData: any): Promise<boolean> {
    const estadoCivil = personalData?.estadoCivil;

    if (!estadoCivil) {
      this.enviarAPaginaDeErrorEstadoCivilValidacion();
      return false;
    }

    const estadoCivilValidado = await firstValueFrom(
      this.tramitePension.validateCivilStatus().pipe(
        catchError(() => of({ success: false } as IValidateCivilStatus))
      )
    );

    if (!estadoCivilValidado.success) {
      this.enviarAPaginaDeErrorEstadoCivilValidacion();
      return false;
    }

    return true;
  }

  /**
   * Obtiene los beneficiarios del servicio y los guarda en storage
   * @returns Array de beneficiarios o null si ocurre un error
   */
  private async obtenerYGuardarBeneficiarios(): Promise<Beneficiary[] | null> {
    try {
      const beneficiaries = await firstValueFrom(
        this.tramitePension.getBeneficiaries().pipe(take(1))
      );

      await this.storageService.set(TP_BENEFICIARIES, beneficiaries);

      return beneficiaries;
    } catch {
      return null;
    }
  }



  private enviarAPaginaDeErrorPorValidacion(mensaje: any) {
    this.loading = false;
    this.tramitePension.setError(mensaje);
    this.router.navigate(
      [`/${ROUTING_TRAMITE_PENSION.BASE_URL}/${REQUEST_ERROR}`],
      { relativeTo: this.activatedRoute }
    );
  }

  private enviarAPaginaDeValidacionSaldoApvc() {
    this.loadingHome = false;
    this.enviarAPaginaDeErrorPorValidacion(MESSAGE.ERROR_APVC_SALDO);
  }

  private manejarCodigoStatusValidacionesTramite(codigoStatus: string): boolean {
    const mapaErrores: Record<string, any> = {
      'AU01': MESSAGE.ERROR_NO_AHORROS_OBLIGATORIOS_AFP_CAPITAL,
      'AU06': MESSAGE.ERROR_SIN_SALDOS_OBLIGATORIOS_AFP_CAPITAL,
      'AU07': MESSAGE.ERROR_LPA_SALDO_RETENIDO,
    };

    if (mapaErrores[codigoStatus]) {
      this.loadingHome = false;
      this.enviarAPaginaDeErrorPorValidacion(mapaErrores[codigoStatus]);
      return true;
    }

    return false;
  }

  private enviarAPaginaDeError(error: any = null) {
    this.loading = false;
    if (error == 'extranjero') {
      this.tramitePension.setError(MESSAGE.ERROR_NO_CUMPLE_REQUISITOS_EXTRANJERO);
    } else {
      this.tramitePension.setError(MESSAGE.ERROR_NO_CUMPLE_REQUISITOS);
    }
    this.router.navigate(
      [`/${ROUTING_TRAMITE_PENSION.BASE_URL}/${REQUEST_ERROR}`],
      { relativeTo: this.activatedRoute }
    );
  }

  private enviarAPaginaDeErrorBeneficiarioConInvalidez() {
    this.tramitePension.setError(MESSAGE.ERROR_BENEFICIARIO_CON_INVALIDEZ);
    this.loading = false;
    this.router.navigate(
      [`/${ROUTING_TRAMITE_PENSION.BASE_URL}/${REQUEST_ERROR}`],
      { relativeTo: this.activatedRoute }
    );
  }

  /**
   * Muestra una sola pantalla de error con lista dinámica para todos los errores agrupados de validación de beneficiarios
   * @param errores Array de errores de validación de beneficiarios encontrados
   */
  private enviarAPaginaDeErrorBeneficiariosAgrupados(errores: TipoErrorValidacionBeneficiarios[]) {
    const listaMensajes: string[] = MENSAJES_LISTA_ERRORES_BENEFICIARIOS
      .filter(item => errores.includes(item.tipo))
      .map(item => item.mensaje);

    // Crear el objeto de error con la lista dinámica
    const errorConListaDinamica = {
      ...MESSAGE.ERROR_BENEFICIARIOS_VALIDACION_AGRUPADA,
      lista: listaMensajes
    };

    this.tramitePension.setError(errorConListaDinamica);
    this.loading = false;
    this.router.navigate(
      [`/${ROUTING_TRAMITE_PENSION.BASE_URL}/${REQUEST_ERROR}`],
      { relativeTo: this.activatedRoute }
    );
  }

  private enviarAPaginaDeErrorEstadoCivilValidacion() {
    this.loading = false;
    this.tramitePension.setError(MESSAGE.ERROR_NO_CUMPLE_CON_ESTADO_CIVIL_VALIDACION);

    this.router.navigate(
      [`/${ROUTING_TRAMITE_PENSION.BASE_URL}/${REQUEST_ERROR}`],
      {
        relativeTo: this.activatedRoute,
      }
    );
  }

  private async validaProductoCliente(): Promise<boolean> {
    const listaProductos = await this.storageService.get(ACCOUNTS);

    if (!Array.isArray(listaProductos) || listaProductos.length === 0) {
      return false;
    }

    return listaProductos.some((producto: any) => {
      const accountId = producto?.accountConfiguration?.id ?? producto?.id ?? "";
      return accountId === "CCO";
    });
  }

  private async clienteTieneSaldoApvc(): Promise<boolean> {
    const cuentas: any[] = (await this.storageService.get(ACCOUNTS)) ?? [];
    if (!Array.isArray(cuentas) || cuentas.length === 0) {
      return false;
    }

    return cuentas.some((cuenta) => {
      const accountId = cuenta?.accountConfiguration?.id ?? cuenta?.id ?? "";
      return accountId === "CVC" && this.obtenerSaldoCuentaEnPesos(cuenta) > 0;
    });
  }

  private obtenerSaldoCuentaEnPesos(cuenta: any): number {
    const funds = cuenta?.funds;
    if (Array.isArray(funds) && funds.length > 0) {
      return funds.reduce((total: number, fund: any) => {
        const subBalances = fund?.subBalances;
        if (Array.isArray(subBalances) && subBalances.length > 0) {
          return (
            total +
            subBalances.reduce(
              (subTotal: number, subBalance: any) =>
                subTotal + Number(subBalance?.clpBalance ?? 0),
              0
            )
          );
        }
        return total + Number(fund?.amount ?? 0);
      }, 0);
    }

    return Number(cuenta?.amount ?? 0);
  }

  private async clienteSinBonoReconocimiento(): Promise<boolean> {
    const listaBonos = await this.storageService.get(RECOGNITION_BONDS);

    if (!listaBonos || listaBonos.length === 0) {
      return true;
    }

    // Crear un array de promesas que validan cada bono
    const resultados = await Promise.all(
      listaBonos.map(async (bono: any) => {
        const request: BonoReconocimiento = {
          estado: bono.bondStatusCode,
          monto: bono.currentValue,
        };
        return (
          (await this.tramitePension.validaBonoReconocimiento(request)) ?? false
        );
      })
    );

    // Retornar true solo si todos los valores son true, sino false
    return resultados.every((resultado) => resultado === true);
  }

  private async checkAfiliadoSinEmpleador(): Promise<boolean> {
    const movements = await this.storageService.get(ULTIMAS_12_COTIZACIONES);
    if (!movements || movements.length === 0) return true;
    const currentDate = new Date();
    const twoMonthsAgo = new Date();
    twoMonthsAgo.setMonth(currentDate.getMonth() - 2);

    // Filtra los movimientos de tipo "COTIZACIÓN"
    const cotizaciones = movements.filter(
      (movement: any) => movement.movementType === "COTIZACIÓN"
    );

    // Verifica si hay algún movimiento dentro de los últimos dos meses
    const hasRecentCotizacion = cotizaciones.some((movement: any) => {
      // Asegúrate de que la fecha esté en formato "DD/MM/YYYY"
      const movementPeriodParts = movement.movementPeriod.split("/");
      const movementPeriod = new Date(
        Number(movementPeriodParts[1]), // Año
        Number(movementPeriodParts[0]) - 1, // Mes (restamos 1 porque los meses en JS son 0-indexados)
        1 // Día
      );

      return movementPeriod >= twoMonthsAgo;
    });

    return !hasRecentCotizacion;
  }

  goToVideoAtencion() {
    this.gtmService.trackClick('link', 'Video atención', 'link_interno', 'modal');
    void this.modalService.openGenericModalMensajeSalida(TipoMensajeSalidaFlujoTramitePension.VideoAtencion);
  }

  goToClara() {
    openClaraChatLauncher();
  }

  goToYourDataModal() {
    this.gtmService.trackClick('button', 'Tus datos', 'link_interno', 'modal');
    void this.modalService.openGenericModalMensajeSalida(TipoMensajeSalidaFlujoTramitePension.ActualizaDatos);
  }

  goToBeneficiariesModal() {
    this.gtmService.trackClick('button', 'Actualizar tus beneficiarios', 'link_interno', 'modal');
    void this.modalService.openGenericModalMensajeSalida(TipoMensajeSalidaFlujoTramitePension.Beneficiario);
  }

  async setprocessInfo() {
    try {
      this.mostrarNumeroTramite = true;
      this.mostrarBotonEstado = false;
      const tipoTramite = await this.obtenerTipoTramiteFlujo();
      const rutAfiliado =
        this.clientInfo?.rut ?? (await this.tramitePension.uid());
      const processInfoResponses = await this.fetchProcessInfoResponses(
        tipoTramite,
        rutAfiliado
      );

      const tramitesSolicitudResponse: TramiteSolicitudPension[] =
        processInfoResponses.solicitudTramiteResponse?.data
          ?.ConsultarTramitePension ?? [];
      this.tramiteSolicitudMasReciente = tramitesSolicitudResponse[0];

      const codigoStatusValidacionesResponse =
        this.getCodigoStatusValidaciones(
          processInfoResponses.validacionesResponse
        );

      // AU01/AU06/AU07 tienen prioridad sobre fallos de otras APIs (error general).
      if (
        codigoStatusValidacionesResponse &&
        this.manejarCodigoStatusValidacionesTramite(
          codigoStatusValidacionesResponse
        )
      ) {
        return;
      }

      // Fallback local: sin CCO → misma pantalla que AU01 (antes del error general).
      if (!(await this.validaProductoCliente())) {
        this.loadingHome = false;
        this.enviarAPaginaDeErrorPorValidacion(
          MESSAGE.ERROR_NO_AHORROS_OBLIGATORIOS_AFP_CAPITAL
        );
        return;
      }

      if (this.hasProcessInfoResponseError(processInfoResponses)) {
        this.enviarAPaginaDeErrorGeneral();
        return;
      }

      if (!codigoStatusValidacionesResponse) {
        this.enviarAPaginaDeErrorGeneral();
        return;
      }

      if (await this.clienteTieneSaldoApvc()) {
        this.enviarAPaginaDeValidacionSaldoApvc();
        return;
      }

      this.applyProcessInfoTramiteStatus(
        tipoTramite,
        codigoStatusValidacionesResponse,
        processInfoResponses.pensionEnTramiteResponse,
        tramitesSolicitudResponse
      );
    } catch (error) {
      console.error("Error en setprocessInfo:", error);
      this.enviarAPaginaDeErrorGeneral();
    } finally {
      this.loadingHome = false;
    }
  }

  private async fetchProcessInfoResponses(tipoTramite: any, rutAfiliado: string) {
    const [
      pensionEnTramiteResponse,
      validacionesResponse,
      solicitudTramiteResponse,
    ] = await Promise.all([
      this.tramitePension
        .getCacheEstadoTramite(this.storageService)
        .catch((err) => ({ error: err })),
      this.tramitePension
        .obtenerValidacionesTramitePension(tipoTramite.tipo)
        .catch((err) => ({ error: err })),
      rutAfiliado
        ? this.tramitePension
          .consultarSolicitudTramitePension()
          .catch((err) => ({ error: err }))
        : Promise.resolve({ error: new Error("RUT no disponible") }),
    ]);

    return {
      pensionEnTramiteResponse,
      validacionesResponse,
      solicitudTramiteResponse,
    };
  }

  private hasProcessInfoResponseError(responses: {
    pensionEnTramiteResponse: any;
    validacionesResponse: any;
    solicitudTramiteResponse: any;
  }): boolean {
    const {
      pensionEnTramiteResponse,
      validacionesResponse,
      solicitudTramiteResponse,
    } = responses;

    return !!(
      pensionEnTramiteResponse?.error ||
      validacionesResponse?.error ||
      solicitudTramiteResponse?.error ||
      solicitudTramiteResponse?.data?.error
    );
  }

  /**
   * Normaliza tipo de trámite desde storage. Otros módulos (ej. estado de trámite)
   * pueden guardar un string en la misma key en lugar del objeto { tipo, descripcion }.
   */
  private async obtenerTipoTramiteFlujo(): Promise<
    (typeof TIPO_TRAMITE_FLUJO)["VEJEZ_NORMAL"]
  > {
    const almacenado = await this.storageService.get(STORAGE_TIPO_TRAMITE);

    if (
      almacenado &&
      typeof almacenado === "object" &&
      typeof almacenado.tipo === "string" &&
      almacenado.tipo.trim()
    ) {
      return almacenado;
    }

    if (almacenado === TIPO_TRAMITE_FLUJO.VEJEZ_NORMAL.tipo) {
      return TIPO_TRAMITE_FLUJO.VEJEZ_NORMAL;
    }

    if (almacenado === TIPO_TRAMITE_FLUJO.VEJEZ_ANTICIPADA.tipo) {
      return TIPO_TRAMITE_FLUJO.VEJEZ_ANTICIPADA;
    }

    return TIPO_TRAMITE_FLUJO.VEJEZ_NORMAL;
  }

  private getCodigoStatusValidaciones(
    validacionesResponse: any
  ): string | undefined {
    return (
      validacionesResponse?.data?.codigoRetorno ||
      validacionesResponse?.data?.codigoStatus
    );
  }

  private applyProcessInfoTramiteStatus(
    tipoTramite: any,
    codigoStatusValidacionesResponse: string,
    pensionEnTramiteResponse: any,
    tramitesSolicitudResponse: TramiteSolicitudPension[]
  ): void {
    const pensionesEnTramiteStorage: PensionEnTramitePension[] =
      pensionEnTramiteResponse?.PensionesEnTramite ?? [];
    const pensionVejezEdadMasRecienteStorage =
      this.obtenerPensionEnTramiteVejezEdadMasReciente(
        pensionesEnTramiteStorage
      );
    const otroTipoTramiteMasRecienteStorage =
      this.obtenerPensionEnTramiteVejezEdadMasReciente(
        pensionesEnTramiteStorage,
        true
      );
    const tieneTramiteEnProcesoValidacion =
      CODIGOS_VALIDACIONES_TRAMITE_EN_PROCESO.includes(
        codigoStatusValidacionesResponse
      );
    const tienePensionVejezEdadEnTramiteEnTramiteStorage =
      pensionVejezEdadMasRecienteStorage !== null;
    const tieneOtroTipoTramiteEnTramiteEnTramiteStorage =
      otroTipoTramiteMasRecienteStorage !== null;
    const tienePensionesEnTramiteSolicitados =
      Array.isArray(tramitesSolicitudResponse) &&
      tramitesSolicitudResponse.length > 0;
    const esAu00ConTramiteYaIngresado =
      codigoStatusValidacionesResponse === CODIGO_VALIDACIONES_EXITOSA &&
      this.coincideNumeroTramiteSolicitudConStorage(
        tramitesSolicitudResponse,
        pensionesEnTramiteStorage
      );

    if (
      tieneTramiteEnProcesoValidacion ||
      tienePensionVejezEdadEnTramiteEnTramiteStorage ||
      esAu00ConTramiteYaIngresado
    ) {
      this.applyTramiteFinalizadoFlow(
        tipoTramite,
        codigoStatusValidacionesResponse,
        pensionVejezEdadMasRecienteStorage,
        tienePensionVejezEdadEnTramiteEnTramiteStorage,
        tienePensionesEnTramiteSolicitados,
        esAu00ConTramiteYaIngresado
      );
      return;
    }

    if (tieneOtroTipoTramiteEnTramiteEnTramiteStorage) {
      this.applyOtroTipoTramiteFlow(otroTipoTramiteMasRecienteStorage);
      return;
    }
    if (this.loadingHome)
      this.applyIniciarTramiteFlow();
  }

  /**
   * AU00 + mismo Nº entre consultar-solicitud[0] y PensionesEnTramite en storage:
   * el afiliado ya ingresó ese trámite en esta sesión/canal.
   */
  private coincideNumeroTramiteSolicitudConStorage(
    tramitesSolicitudResponse: TramiteSolicitudPension[],
    pensionesEnTramiteStorage: PensionEnTramitePension[]
  ): boolean {
    const numeroSolicitud = String(
      tramitesSolicitudResponse[0]?.numeroTramite ?? ""
    ).trim();
    if (!numeroSolicitud) {
      return false;
    }

    return pensionesEnTramiteStorage.some(
      (pension) =>
        String(pension.numeroTramite ?? "").trim() === numeroSolicitud
    );
  }

  private applyTramiteFinalizadoFlow(
    tipoTramite: any,
    codigoStatusValidacionesResponse: string,
    pensionVejezEdadMasRecienteStorage: PensionEnTramitePension | null,
    tienePensionVejezEdadEnTramiteEnTramiteStorage: boolean,
    tienePensionesEnTramiteSolicitados: boolean,
    esAu00ConTramiteYaIngresado = false
  ): void {
    this.currentFlow = TramitePensionFlowsEnum.TRAMITE_FINALIZADO;
    this.statusFlow = TramitePensionFlowsEnum.TRAMITE_FINALIZADO;

    const esTramiteEnCurso =
      CODIGOS_VALIDACIONES_TRAMITE_EN_CURSO.includes(
        codigoStatusValidacionesResponse
      ) || esAu00ConTramiteYaIngresado;

    this.statusInfo = esTramiteEnCurso
      ? LabelStatus.TRAMITE_EN_CURSO
      : LabelStatus.TRAMITE_FINALIZADO;
    this.mostrarBotonEstado =
      tienePensionVejezEdadEnTramiteEnTramiteStorage ||
      esAu00ConTramiteYaIngresado;

    if (tienePensionesEnTramiteSolicitados) {
      this.estadoTramite = this.buildEstadoTramiteDesdeSolicitud(tipoTramite);
      return;
    }

    this.statusInfo = LabelStatus.TRAMITE_EN_CURSO;
    this.estadoTramite = {
      descripcionTipoTramite: tipoTramite.descripcion,
      fechaSolicitudTramite:
        pensionVejezEdadMasRecienteStorage?.fechaSolicitudTramite ?? "",
      numeroTramite: pensionVejezEdadMasRecienteStorage?.numeroTramite,
    };
  }

  private buildEstadoTramiteDesdeSolicitud(
    tipoTramite: any
  ): PensionEnTramitePension {
    if (this.tramiteSolicitudMasReciente) {
      return {
        descripcionTipoTramite: tipoTramite.descripcion,
        fechaSolicitudTramite:
          this.tramiteSolicitudMasReciente.fechaSolicitudTramite,
        numeroTramite: this.tramiteSolicitudMasReciente.numeroTramite,
      };
    }

    return {
      descripcionTipoTramite: tipoTramite.descripcion,
      fechaSolicitudTramite: "",
    };
  }

  private applyOtroTipoTramiteFlow(
    otroTipoTramiteMasRecienteStorage: PensionEnTramitePension
  ): void {
    this.statusInfo = LabelStatus.TRAMITE_EN_CURSO;
    this.estadoTramite = {
      descripcionTipoTramite: this.util.formatTipoTramitePension(
        otroTipoTramiteMasRecienteStorage?.descripcionTipoTramite
      ),
      fechaSolicitudTramite:
        otroTipoTramiteMasRecienteStorage?.fechaSolicitudTramite ?? "",
    };
  }

  private applyIniciarTramiteFlow(): void {
    this.statusInfo = LabelStatus.INICIAR_TRAMITE;

    this.routerSubscription = this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map((event: NavigationEnd) => event.urlAfterRedirects),
        distinctUntilChanged()
      )
      .subscribe(async () => {
        if (this.esRutaHome()) {
          await this.abrirModalBeneficiosReforma();
        }
      });

    void this.abrirModalBeneficiosReforma();
  }

  private obtenerPensionEnTramiteVejezEdadMasReciente(
    pensionesEnTramite?: PensionEnTramitePension[],
    excluirVejezEdad = false
  ): PensionEnTramitePension | null {
    if (!Array.isArray(pensionesEnTramite) || pensionesEnTramite.length === 0) {
      return null;
    }

    const pensionesFiltradas = pensionesEnTramite.filter((pension) =>
      excluirVejezEdad
        ? !this.esPensionVejezEdad(pension)
        : this.esPensionVejezEdad(pension)
    );

    if (pensionesFiltradas.length === 0) {
      return null;
    }

    let masReciente: PensionEnTramitePension | null = null;
    let fechaMasReciente: Date | null = null;

    for (const pension of pensionesFiltradas) {
      const fecha = this.parseFechaDdMmYyyy(pension.fechaSolicitudTramite);
      if (!fecha) {
        continue;
      }
      if (!fechaMasReciente || fecha > fechaMasReciente) {
        fechaMasReciente = fecha;
        masReciente = pension;
      }
    }

    return masReciente;
  }

  private esPensionVejezEdad(pension: PensionEnTramitePension): boolean {
    return (
      pension.descripcionTipoTramite?.trim().toLowerCase() ===
      VEJEZ_EDAD.toLowerCase()
    );
  }

  private parseFechaDdMmYyyy(fecha: string | null | undefined): Date | null {
    if (!fecha?.trim()) {
      return null;
    }
    const partes = fecha.trim().split("/");
    if (partes.length !== 3) {
      return null;
    }
    const dia = Number.parseInt(partes[0], 10);
    const mes = Number.parseInt(partes[1], 10);
    const anio = Number.parseInt(partes[2], 10);
    if (Number.isNaN(dia) || Number.isNaN(mes) || Number.isNaN(anio)) {
      return null;
    }
    const fechaParsed = new Date(anio, mes - 1, dia);
    if (
      fechaParsed.getFullYear() !== anio ||
      fechaParsed.getMonth() !== mes - 1 ||
      fechaParsed.getDate() !== dia
    ) {
      return null;
    }
    return fechaParsed;
  }

  private esRutaHome(): boolean {
    const url = this.location.path();
    const urlWithHash = this.router.url;

    if (url !== `/${ROUTING_TRAMITE_PENSION.BASE_URL}`) {
      return false;
    }

    // para bug navegacion con hash en home
    if (urlWithHash.includes('#')) {
      return false;
    }

    return true;
  }

  private async abrirModalBeneficiosReforma(): Promise<void> {
    this.modalBeneficiosReforma = await this.tramitePension.getCacheModalBeneficiosReforma(this.storageService);
    this.modalActivado = await this.storageService.get(TP_MODAL_ACTIVO);
    if (!this.esRutaHome()) {
      return;
    }
    if (this.modalBeneficiosReforma?.ENABLE) {
      if (this.modalTimer) clearTimeout(this.modalTimer);
      this.modalTimer = setTimeout(() => {
        if (!this.esRutaHome()) {
          return;
        }

        if (this.modalActivado) {
          return;
        }

        this.openModalReformaTramitePension(this.modalBeneficiosReforma);
      }, 3000);
    }
  }

  goToHome() {
    this.router.navigate([INICIO]);
  }

  goToEstadoTramite(): void {
    this.router.navigate([
      ROUTING_ESTADO_TRAMITE_PENSION.ESTADO_TRAMITE_PENSION_BASE,
      ROUTING_ESTADO_TRAMITE_PENSION.ESTADO_TRAMITE_PENSION_URL,
      ROUTING_ESTADO_TRAMITE_PENSION.ESTADO_TRAMITE_PENSION_HOME,
    ]);
  }

  // 4. Agregar método ngOnDestroy
  ngOnDestroy() {
    this.limpiarSalida();
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  ionViewWillLeave() {
    this.necesitaReinicializar = true;
    this.limpiarSalida();
  }

  limpiarSalida() {
    if (this.modalTimer) {
      clearTimeout(this.modalTimer);
    }
  }

  abrirRegistroCivil(event: Event): void {
    event.preventDefault();

    this.gtmService.trackClick('link', 'www.registrocivil.cl', 'link_externo', 'www.registrocivil.cl');
    window.open(
      'https://www.registrocivil.cl/',
      '_blank',
      'noopener,noreferrer'
    );
  }
}
